class LocalCache {
  setCache(key: string, value: any) {
    if (typeof value === "string") {
      localStorage.setItem(key, value);
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }

  getCache(key: string) {
    const value = localStorage.getItem(key);
    if (!value) return null;

    try {
      return JSON.parse(value);
    } catch {
      return value; // 返回原始字符串
    }
  }

  deleteCache(key: string) {
    localStorage.removeItem(key);
  }

  clearCache() {
    localStorage.clear();
  }
}

export default new LocalCache();
